
export const IsMobile = () => {
    return window.innerWidth <= 768 ;
}
